import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 6h16","key":"svg-0"}],["path",{"d":"M6 12h12","key":"svg-1"}],["path",{"d":"M9 18h3","key":"svg-2"}],["path",{"d":"M17 21l4 -4m-5 2c0 .796 .316 1.559 .879 2.121c.563 .563 1.326 .879 2.121 .879c.796 0 1.559 -.316 2.121 -.879c.563 -.563 .879 -1.326 .879 -2.121c0 -.796 -.316 -1.559 -.879 -2.121c-.563 -.563 -1.326 -.879 -2.121 -.879c-.796 0 -1.559 .316 -2.121 .879c-.563 .563 -.879 1.326 -.879 2.121l1 2","key":"svg-3"}]]

const IconFilter2Cancel = createReactComponent('outline', 'filter-2-cancel', 'Filter2Cancel', __iconNode);

export default IconFilter2Cancel;